// import * as mapbox_gl from 'mapbox-gl';
const token = 'pk.eyJ1Ijoiam9uY2xhd3NvbiIsImEiOiJjbGtycWsxZXUxZzUwM2Zwcm9pb3loaDdwIn0.ov_v9NV9rGjLnonE0uGXfA';
// mapbox_gl.accessToken =
//   token;

export default {key: token };
